import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableDecline = loadable(() => import('./Decline'), {
  fallback: <LoadingScreen />,
});

export default LoadableDecline;
